import { render } from "./TheProfessionalVideoShow.vue?vue&type=template&id=1b630910&scoped=true&ts=true"
import script from "./TheProfessionalVideoShow.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalVideoShow.vue?vue&type=script&lang=ts"

import "./TheProfessionalVideoShow.vue?vue&type=style&index=0&id=1b630910&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b630910"]])

export default __exports__